import client, { mock, isRealApiEnabled } from "./client";
import audienceGroupsMock from "./mocks/audienceGroups";

/**
 * @endpoint GET /api/v1/audience-groups
 * @returns {Promise<AudienceGroup[]>}
 */
export function list() {
  if (isRealApiEnabled()) return client.get("/v1/audience-groups");
  return mock(audienceGroupsMock);
}

/**
 * @endpoint GET /api/v1/audience-groups/:id
 * @returns {Promise<AudienceGroup>}
 */
export function get(id) {
  if (isRealApiEnabled())
    return client.get(`/v1/audience-groups/${encodeURIComponent(id)}`);
  return mock(
    audienceGroupsMock.find((a) => a.id === id) || audienceGroupsMock[0]
  );
}

/**
 * @endpoint POST /api/v1/audience-groups
 * @returns {Promise<AudienceGroup>}
 */
export function create(payload) {
  if (isRealApiEnabled()) return client.post("/v1/audience-groups", payload);
  return mock({
    ...audienceGroupsMock[0],
    ...payload,
    id: `aud_new_${Date.now()}`,
  });
}

/**
 * @endpoint PATCH /api/v1/audience-groups/:id
 * @returns {Promise<AudienceGroup>}
 */
export function update(id, payload) {
  if (isRealApiEnabled())
    return client.patch(
      `/v1/audience-groups/${encodeURIComponent(id)}`,
      payload
    );
  const base =
    audienceGroupsMock.find((a) => a.id === id) || audienceGroupsMock[0];
  return mock({ ...base, ...payload, id });
}

/**
 * @endpoint DELETE /api/v1/audience-groups/:id
 * @returns {Promise<{id: string, deleted: true}>}
 */
function deleteGroup(id) {
  if (isRealApiEnabled())
    return client.del(`/v1/audience-groups/${encodeURIComponent(id)}`);
  return mock({ id, deleted: true });
}

export { deleteGroup as delete };
